<template>
  <div class="nav-add-wrap">
    <edit-popover ref="$popover" :target="current" :keys="[targetKey, targetIndex]" :site="site" target-key="navs" :target-index="currentIndex" :hide-funs="hideFuns" :filter-modules="filterModules" :menu-sections="menuSections" />
    <draggable v-model="model.navs" v-bind="dragOptions">
      <menu-item v-for="(n, i) in model.navs" :key="i" class="pt-0">
        <div class="navs mb-2">
          <div class="nav-item flex items-center justify-between">
            <div class="label overflow-hidden truncate" :class="{ 'icon': true }">{{ n.label }}</div>
            <div class="right flex items-center">
              <div class="flex justify-center items-center w-24px h-24px text-textColor-3 hover:text-textColor-5 move-btn hover:bg-fillColor-2 cursor-move" @click="editNav(n, i)">
                <icon-sort class="text-14" />
              </div>
              <div class="flex justify-center items-center w-24px h-24px text-textColor-3 hover:text-textColor-5 hover:bg-fillColor-2 cursor-pointer" @click="editNav(n, i)">
                <icon-edit class="text-14" />
              </div>
              <div class="flex justify-center items-center w-24px text-textColor-3 h-24px hover:text-textColor-5 hover:bg-fillColor-2 cursor-pointer" @click="deleteNav(i)">
                <icon-delete class="text-14 text-white" />
              </div>
            </div>
          </div>
        </div>
      </menu-item>
    </draggable>
    <menu-item v-if="maxLength > model.navs.length" class="mt-4 pt-0">
      <div class="add-nav">
        <div class="btn flex items-center justify-center" @click="addNav">
          <icon-add />
          <span class="ml-2 text-white text-12">{{ $t('head.addnav') }}</span>
          <span class="ml-2 text-white text-12">{{ model.navs.length }} / {{ maxLength }}</span>
        </div>
      </div>
    </menu-item>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import { cloneDeep } from 'lodash-es'
import { uid } from 'uid'
import EditPopover from "~/site/components/editMenu/editPopover.vue";
import iconAdd from '@/assets/svg/icon/iconUpload.svg'
import iconEdit from '@/assets/svg/icon/iconEdit.svg'
import iconDelete from '@/assets/svg/icon/iconDelete.svg'
import iconSort from '@/assets/svg/icon/iconMove.svg'
import MenuItem from '~/components/menu/menuItem'
import { insertStep } from "~/utils/event";
import { generateDefaultBackground } from "~/site/model/helper";

export default {
  name: "NavAdd",
  components: {
    MenuItem,
    iconDelete,
    iconAdd,
    iconEdit,
    iconSort,
    EditPopover,
    draggable
  },
  props: {
    hideFuns: Array,
    menuSections: {
      type: Object,
      default() {
        return {}
      }
    },
    site: {
      type: Object,
      default() {
        return {}
      }
    },
    maxLength: {
      type: Number,
      default: 99
    },
    targetKey: {
      type: String,
      default: ''
    },
    filterModules: Array,
    targetIndex: {
      type: [Number, String],
      default: ''
    },
    model: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  data() {
    return {
      editIndex: null,
      current: {},
      currentIndex: -1,
      navs: [
        {
          key: 1,
          label: '主页',
          url: '',
        },
        {
          key: 2,
          label: '产品目录',
          url: '',
        },
        {
          key: 3,
          label: '联系方式',
          url: '',
        },
      ],
      dragOptions: {
        disabled: false,
        animation: 120,
        handle: '.move-btn'
      }
    }
  },
  methods: {
    addNav() {
      const navs = cloneDeep(this.model.navs)
      insertStep(this, [this.targetKey, this.targetIndex, 'navs'], navs)
      this.$store.commit('editor/CLEAR_STORAGE_STEP')
      const option = {
        key: uid(),
        label: `菜单`,
        navType: '1',
        url: '',
        model: '',
        page: '',
        pagePath: [],
        icon: generateDefaultBackground()
      }
      this.model.navs.push(option)
    },
    deleteNav(i) {
      const navs = cloneDeep(this.model.navs)
      this.model.navs.splice(i, 1)
      insertStep(this, [this.targetKey, this.targetIndex, 'navs'], navs)
      this.$store.commit('editor/CLEAR_STORAGE_STEP')
    },
    editNav(n, i) {
      this.current = n
      this.currentIndex = i
      this.$refs.$popover.init()
    }
  }
}
</script>

<style lang='less' scoped>
.nav-add-wrap {
  .navs {
    .nav-item {
      height: 36px;
      background: rgba(255, 255, 255, 0.05);
      padding: 0 8px;
      border-radius: 8px;
      border: 1px solid rgba(255, 255, 255, 0.1);
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

      &:hover {
        background: rgba(255, 255, 255, 0.08);
        border-color: rgba(255, 255, 255, 0.2);
        transform: translateX(2px);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

        .right {
          opacity: 1;
          transform: translateX(0);
        }
      }

      .label {
        font-size: 13px;
        color: rgba(255, 255, 255, 0.8);
        font-weight: 500;
        padding-left: 16px;
        position: relative;
        height: 20px;
        line-height: 20px;
      }

      .label.icon::before {
        display: block;
        content: '';
        position: absolute;
        top: 8px;
        left: 0;
        width: 4px;
        height: 4px;
        background: var(--primary-color);
        border-radius: 100%;
        box-shadow: 0 0 4px rgba(var(--primary-color-rgb), 0.6);
      }

      .right {
        opacity: 0.6;
        transition: all 0.3s ease;
        transform: translateX(4px);

        &>div {
          border-radius: 4px;
          transition: all 0.2s;
          color: rgba(255, 255, 255, 0.6);

          &:hover {
            background: rgba(255, 255, 255, 0.1);
            color: white;

            .text-white {
              color: #ff4d4f !important; // 删除按钮变红
            }
          }
        }
      }
    }
  }

  .add-nav {
    width: 100%;

    .btn {
      line-height: 36px;
      height: 36px;
      padding: 0 16px;
      cursor: pointer;
      border: 1px dashed rgba(255, 255, 255, 0.2);
      border-radius: 8px;
      background: rgba(255, 255, 255, 0.02);
      transition: all 0.3s ease;

      span {
        font-weight: 500;
        color: rgba(255, 255, 255, 0.7);
      }

      svg {
        opacity: 0.7;
        transition: transform 0.3s ease;
      }

      &:hover {
        background: rgba(255, 255, 255, 0.05);
        border-color: var(--primary-color);
        color: var(--primary-color);

        span {
          color: var(--primary-color);
        }

        svg {
          opacity: 1;
          transform: rotate(90deg);

          path {
            fill: var(--primary-color);
          }
        }
      }

      &:active {
        background: rgba(255, 255, 255, 0.08);
        transform: translateY(1px);
      }
    }
  }
}
</style>
